module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/MATERIAL SCIENCE-5ee3b5f9e54ad6ae5347af03cfba3364.png";